/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$third-level-navigation-tab-border-width: 4px !default; // eon-ui-tabs component is responsible for setting this var
$third-level-navigation-tab-padding: 24px !default; // eon-ui-tabs component is responsible for setting this var

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

.#{$prefix}link {
  @include eon-typography(copy);
  display: block;
  border: 0;
  padding-top: $third-level-navigation-tab-padding - 2;
  padding-right: $third-level-navigation-tab-padding;
  padding-left: $third-level-navigation-tab-padding;
  padding-bottom: $third-level-navigation-tab-padding - 2 - $third-level-navigation-tab-border-width;

  text-decoration: none;
  margin: 0px;
  outline: none;
  cursor: pointer;
  color: v(textColor);
  white-space: nowrap;

  &.#{$prefix}firstNavItem {
    @include for-size(tablet-or-larger) {
      padding-left: 16px;
    }
  }

  @include for-size(phone) {
    padding-top: $third-level-navigation-tab-padding * 0.5;
    padding-bottom: $third-level-navigation-tab-padding * 0.5 - $third-level-navigation-tab-border-width;
    padding-left: customDivide($third-level-navigation-tab-padding, 3);
    padding-right: customDivide($third-level-navigation-tab-padding, 3);
  }

  &:hover,
  &:focus {
    background: v(tabHoverColor);
    color: v(textHoverColor);
    border-bottom: $third-level-navigation-tab-border-width solid v(tabHoverBorderColor);
  }
}
